module.exports = __webpack_public_path__ + "static/media/Sekcja1.dce9fba9.jpg";